module.exports = __webpack_public_path__ + "static/media/logo.fa0ba753.png";